import { Injectable } from '@angular/core';
import ImageKit from 'imagekit-javascript';
import {DjangoApiService} from "./django-api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {
  private imageKit: ImageKit;
  private apiEndpoint = 'https://api.imagekit.io/v1/files';
  private imageKitPrivateKey = environment.imageKitPrivateKey;

  constructor(private _djangoApiService: DjangoApiService,
              private http: HttpClient,) {
    this.imageKit = new ImageKit({
      urlEndpoint: 'https://ik.imagekit.io/tlob',
      publicKey: environment.imageKitPublicKey
    });
  }

  async uploadImage(file: File): Promise<any> {
    try {
      const authParams = await this._djangoApiService.fetchImageKitAuth().toPromise();
      const response = await this.imageKit.upload({
        file: file,
        fileName: file.name,
        folder: '/blumer-partner',
        signature: authParams.signature,
        token: authParams.token,
        expire: authParams.expire,
        useUniqueFileName: true,
      });
      return response;
    } catch (error) {
      console.error("Error uploading to ImageKit:", error);
      throw error;
    }
  }

  // Fetch a list of media from ImageKit
  listMedia(): Promise<any> {
    const url = `${this.apiEndpoint}?path=%2Fblumer-partner&limit=20`; // Adjust the path and limit as needed
    const headers = new HttpHeaders({
      Authorization: `Basic ${btoa(this.imageKitPrivateKey + ':')}`
    });

    return this.http.get(url, { headers }).toPromise();
  }

  // New Delete method using REST API
  deleteImage(fileId: string): Promise<any> {
    const url = `${this.apiEndpoint}/${fileId}`;
    const headers = new HttpHeaders({
      Authorization: `Basic ${btoa(this.imageKitPrivateKey + ':')}`
    });

    return this.http.delete(url, { headers }).toPromise();
  }
}
